export default __webpack_public_path__ + "23f950494ad786bda079d69c42fb12dc.jpg";